module.exports = __webpack_public_path__ + "static/media/4.11.5a10fc74.png";